<template>
  <div class="main print-no-padding drugsManagement">
    <el-card>
      <clinic-plan-search-bar :search-params="searchParams" @change="change" @search="search" @reset="reset" />
      <div class="handle-bar">
        <el-button size="small" class="btn" @click="handleExcelModal">批量导入</el-button>
        <el-button size="small" class="btn" @click="handleExcelExport">批量导出</el-button>
      </div>
      <clinicDrugsManagementTable
        :page-no="searchParams.pageNo"
        :page-size="searchParams.pageSize"
        :data="data"
        :total="total"
        @handle-pageNo="handlePageNo"
        @handle-pageSize="handlePageSize"
        @refresh="init"
      />
    </el-card>
    <clinicUploadExcel :visible="visible" @close="handleExcelModal" @refresh="search" />
  </div>
</template>

<script>
import Fetch from '@/api';
import clinicDrugsManagementTable from './components/clinicDrugsManagementTable.vue';
import clinicUploadExcel from './components/clinicUploadExcel.vue';
import { MessageBox } from 'element-ui';
import router from '../../router';
import ClinicPlanSearchBar from './components/clinicPlanSearchBar.vue';

export default {
  name: 'clinicPlanDrugList',
  components: {
    clinicDrugsManagementTable,
    clinicUploadExcel,
    ClinicPlanSearchBar
  },
  data() {
    return {
      visible: false,
      searchParams: {
        drugName: '',
        barcode: '',
        medicalInsuranceCode: '',
        pageNo: 1,
        pageSize: 10
      },
      data: [],
      total: 0
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    handleExcelModal() {
      this.visible = !this.visible;
    },
    change(key, val) {
      this.searchParams[key] = val;
    },
    fetchDrugPage(params) {
      console.log(params);
      return Fetch.query_company_medical_drug_page(params).then(({ data, pageNo, pageSize, totalCount }) => {
        this.data = data;
        this.total = totalCount;
        this.searchParams.pageNo = pageNo;
        this.searchParams.pageSize = pageSize;
      });
    },
    init() {
      // 获取药店是否支持商品编码及导入模板地址
      this.$store.dispatch('drugsManagement/FetchDrugSetting');

      return this.fetchDrugPage(this.searchParams);
    },
    reset() {
      // 清空搜索参数
      this.searchParams.drugName = '';
      this.searchParams.barcode = '';
      this.searchParams.medicalInsuranceCode = '';
      this.searchParams.pageNo = 1;
      this.searchParams.pageSize = 10;
    },
    search() {
      const { drugName, barcode, medicalInsuranceCode } = this.searchParams;
      return this.fetchDrugPage({ drugName, barcode, medicalInsuranceCode, pageNo: 1, pageSize: 10 });
    },
    handlePageNo(pageNo) {
      const { drugName, barcode, medicalInsuranceCode, pageSize } = this.searchParams;
      return this.fetchDrugPage({ drugName, barcode, medicalInsuranceCode, pageNo, pageSize });
    },
    handlePageSize(pageSize) {
      const { drugName, barcode, medicalInsuranceCode, pageNo } = this.searchParams;
      return this.fetchDrugPage({ drugName, barcode, medicalInsuranceCode, pageNo, pageSize });
    },
    handleExcelExport() {
      Fetch.exportMedicalDrugs().then(res => {
        MessageBox.confirm('文件正在生成中，请前往下载中心进行下载', '数据导出成功', {
          center: true,
          confirmButtonText: '前往下载中心下载',
          cancelButtonText: '稍后下载',
          beforeClose(action, instance, done) {
            switch (action) {
              case 'confirm':
                done();
                router.push('/download');
                break;
              case 'cancel':
              case 'close':
                done();
                break;
            }
          }
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.handle-bar {
  margin-bottom: 8px;
}
</style>
